import React, { useState, useEffect, useRef } from "react";

import {
    Button,
    Dialog,
    Grid,
    Icon,
    Paper,
    RadioGroup,
    Typography,
    Container,
    Divider,
    TextField,
    FormLabel,
    FormHelperText,
    FormControl,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Radio,
    Select,
} from "@material-ui/core";

import Scrollbars from "rc-scrollbars";
import CloseIcon from "@material-ui/icons/Close";
import {
    Label,
    DraggableComponent,
} from "../../../components/UiElements/UiElements";
import { PostDataAPI } from "../../../Services/APIService";
import { withSnackbar } from "../../../components/Message/Alert";
import useStyles from "./styles";
import {
    validateEmail,
    validatePhoneNumber,
    allowedAttachmentsImages,
    handleNumberKeyPress,
    getFormatedDate,
    formatDateTime,
    formatDate,
} from "../../../../src/components/Common/Extensions";
/*import PreviewPhoto from "../../../assets/img/previewImg.png";*/
import Logo from "../../../assets/img/floridaHeadFoundation.png";

import axios from "axios";
import DialogLoader from "../../../components/Loader/DialogLoader";
import Tooltip from '@material-ui/core/Tooltip';
import SimCardIcon from '@material-ui/icons/SimCard';
import SignalCellularNoSimIcon from '@material-ui/icons/SignalCellularNoSim';
import { HealthcareTabletProgramApplyFor } from "../../../components/Common/AppEnums";

function Preview({
    dialogOpenClose,
    handleClose,
    handleSuccessClose,
    record,
    ...props
}) {
    const classes = useStyles();
    const [state, setState] = useState({});
    const [unixTimestamp, setUnixTimestamp] = useState(0);
    useEffect(() => {
        console.log(record);
        debugger
        if (record && record.applicationId > 0) {
            var option = record && record.ssn ? "SSN" : "TribalIdentification";
            setState(record);
            if (record.updateDate)
                setUnixTimestamp(Math.floor(new Date(record.updateDate).getTime() / 1000));
        }
    }, []);

    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            disableBackdropClick
            disableEscapeKeyDown
            open={dialogOpenClose}
            PaperComponent={DraggableComponent}
            maxWidth="lg"
            {...props}
        >
            <div className={classes.dialogContent}>
                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        <div className={classes.headerLogo}>
                            <img src={Logo} />
                        </div>

                        <Icon
                            className={classes.closeIcon}
                            onClick={handleClose}
                            color="primary"
                        >
                            <CloseIcon />
                        </Icon>
                    </div>
                    <Scrollbars autoHeight autoHeightMax={window.max1550 ? 500 : window.max1300 ? 400 : 700}>
                        <Container>
                            <Grid row spacing={2}>
                                <Grid container className={classes.containerStyle}>
                                    <Grid item xs={12} sm={state.status !== 'Pending' ? 4 : 6}>
                                        <Typography
                                            variant="h4"
                                            gutterBottom
                                            className={classes.gridHeader}
                                        >
                                            Personal Information
                                        </Typography>
                                        <Grid item xs={12} sm={12}>
                                            <Typography variant="h6" className={classes.gridValue}>
                                                <span>
                                                    <span>First Name</span>
                                                    <span>: </span>
                                                </span>
                                                <span>{state.firstName}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={12}>
                                            <Typography variant="h6" className={classes.gridValue}>
                                                <span>
                                                    <span>Middle Name</span>
                                                    <span>: </span>
                                                </span>
                                                <span>{state.middleName}</span>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Typography variant="h6" className={classes.gridValue}>
                                                <span>
                                                    <span>Last Name</span>
                                                    <span>: </span>
                                                </span>
                                                <span>{state.lastName}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={12}>
                                            <Typography variant="h6" className={classes.gridValue}>
                                                <span>
                                                    <span>
                                                        {record.ssn ? "SSN" : "TIN"}
                                                    </span>
                                                    <span>: </span>
                                                </span>
                                                <span>{record.ssn ? state.ssn : state.tin}</span>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Typography variant="h6" className={classes.gridValue}>
                                                <span>
                                                    <span>Date of Birth</span>
                                                    <span>: </span>
                                                </span>
                                                <span>{state.dob}</span>
                                            </Typography>
                                        </Grid>
                                    </Grid>

                                    <Divider variant="fullWidth" />

                                    <Grid item xs={12} sm={state.status !== 'Pending' ? 4 : 6}>
                                        <Typography
                                            variant="h4"
                                            gutterBottom
                                            className={classes.gridHeader}
                                        >
                                            Contact Information
                                        </Typography>
                                        <Grid item xs={12} sm={12}>
                                            <Typography variant="h6" className={classes.gridValue}>
                                                <span>
                                                    <span>Phone</span>
                                                    <span>: </span>
                                                </span>
                                                <span>{state.phone}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={12}>
                                            <Typography variant="h6" className={classes.gridValue}>
                                                <span>
                                                    <span>Email</span>
                                                    <span>: </span>
                                                </span>
                                                <span>{state.email}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={12}>
                                            <Typography variant="h6" className={classes.gridValue}>
                                                <span>
                                                    <span>Address</span>
                                                    <span>: </span>
                                                </span>
                                                <span>{state.address1}</span>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Typography variant="h6" className={classes.gridValue}>
                                                <span>
                                                    <span>Apartment, Unit, etc</span>
                                                    <span>: </span>
                                                </span>
                                                <span>{state.address2}</span>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Typography variant="h6" className={classes.gridValue}>
                                                <span>
                                                    <span>City</span>
                                                    <span>: </span>
                                                </span>
                                                <span>{state.city}</span>
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={12}>
                                            <Typography variant="h6" className={classes.gridValue}>
                                                <span>
                                                    <span>State</span>
                                                    <span>: </span>
                                                </span>
                                                <span>{state.state}</span>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Typography variant="h6" className={classes.gridValue}>
                                                <span>
                                                    <span>ZIP</span>
                                                    <span>: </span>
                                                </span>
                                                <span>{state.zipCode}</span>
                                            </Typography>
                                        </Grid>
                                    </Grid>



                                    {state.status == 'Delivered' && (
                                        <Grid item xs={12} sm={4}>
                                            <Typography
                                                variant="h4"
                                                gutterBottom
                                                className={classes.gridHeader}
                                            >
                                                Proof of Delivery
                                            </Typography>
                                            <Grid item xs={12} sm={12}>
                                                <Typography variant="h6" className={classes.gridValue}>
                                                    <span>
                                                        <span>Device ID</span>
                                                        <span>: </span>
                                                    </span>
                                                    <span>{state.deviceIdentification}</span>
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={12}>
                                                <Typography variant="h6" className={classes.gridValue}>
                                                    <span>
                                                        <span>SIM Card Number</span>
                                                        <span>: </span>
                                                    </span>
                                                    <span>{state.icc}</span>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12}>
                                                <Typography variant="h6" className={classes.gridValue}>
                                                    <span>
                                                        <span>Assigned Phone Number</span>
                                                        <span>: </span>
                                                    </span>
                                                    <span>{state.assignedPhoneNumber}</span>
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={12}>
                                                <Typography variant="h6" className={classes.gridValue}>
                                                    <span>
                                                        <span>Collected By</span>
                                                        <span>: </span>
                                                    </span>
                                                    <span>{state.collectedBy}</span>
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={12}>
                                                <Typography variant="h6" className={classes.gridValue}>
                                                    <span>
                                                        <span>Delivery Date</span>
                                                        <span>: </span>
                                                    </span>
                                                    <span>{state.deliveryDate}</span>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12}>
                                                <Typography variant="h6" className={classes.gridValue}>
                                                    <span>
                                                        <span>Activation Date</span>
                                                        <span>: </span>
                                                    </span>
                                                    <span>{formatDateTime(state.activationDate)}</span>
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    )}


                                    {/* {state.applyFor == HealthcareTabletProgramApplyFor.Beneficiary && state.programBeneficiaries && ( */}
                                    {state.programBeneficiaries && (
                                        <Grid item xs={12} sm={12} md={12} lg={12}>
                                            <Typography
                                                variant="h4"
                                                gutterBottom
                                                className={classes.gridHeader}
                                            >
                                                Recipient Information
                                            </Typography>

                                            <table className={classes.activationTable}>
                                                <tr className={'headerRow'}>
                                                    <th>Full Name</th>
                                                    <th>SSN</th>
                                                    <th>Date of Birth</th>
                                                    <th>School Name</th>
                                                    <th>IMEI #</th>
                                                    <th>SIM Card #</th>
                                                    <th>Assigned Phone #</th>
                                                    <th>Activation Date</th>
                                                </tr>

                                                {
                                                    state.programBeneficiaries?.map((child, index) => (
                                                        <tr>
                                                            <td>
                                                                {child.firstName}  {child.lastName}
                                                            </td>
                                                            <td>
                                                                {child.ssn === "null" || child.ssn == null || child.ssn === 'undefined' ? '' : child.ssn}
                                                            </td>
                                                            <td>
                                                                {formatDate(child.dateOfBirth)}
                                                            </td>
                                                            <td>
                                                                {child.school === "null" || child.school == null || child.school === 'undefined' ? '' : child.school}
                                                            </td>
                                                            <td>
                                                                {child.deviceIdentification === "null" || child.deviceIdentification == null || child.deviceIdentification === 'undefined' ? '' : child.deviceIdentification}

                                                            </td>
                                                            <td>
                                                                {child.icc === "null" || child.icc == null || child.icc === 'undefined' ? '' : child.icc}
                                                            </td>
                                                            <td>
                                                                {child.assignedPhoneNumber === "null" || child.assignedPhoneNumber == null || child.assignedPhoneNumber === 'undefined' ? '' : child.assignedPhoneNumber}
                                                            </td>
                                                            <td>
                                                                {formatDateTime(child.activationDate)}
                                                            </td>

                                                        </tr>

                                                    ))
                                                }
                                            </table>
                                        </Grid>
                                    )}



                                    {state.status == 'Enrolled' && (
                                        <Grid item xs={12} sm={4}>
                                            <Typography
                                                variant="h4"
                                                gutterBottom
                                                className={classes.gridHeader}
                                            >
                                                Enrollment Information
                                            </Typography>
                                            <Grid item xs={12} sm={12}>
                                                <Typography variant="h6" className={classes.gridValue}>
                                                    <span>
                                                        <span>Device ID</span>
                                                        <span>: </span>
                                                    </span>
                                                    <span>{state.deviceIdentification}</span>
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={12}>
                                                <Typography variant="h6" className={classes.gridValue}>
                                                    <span>
                                                        <span>SIM Card Number</span>
                                                        <span>: </span>
                                                    </span>
                                                    <span>{state.icc}</span>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12}>
                                                <Typography variant="h6" className={classes.gridValue}>
                                                    <span>
                                                        <span>Assigned Phone Number</span>
                                                        <span>: </span>
                                                    </span>
                                                    <span>{state.assignedPhoneNumber}</span>
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>

                            <Divider variant="fullWidth" />

                            <Grid row spacing={2}>
                                <Grid container className={classes.containerStyle}>
                                    <Grid item xs={12} sm={state.status == 'Delivered' ? 6 : 12}>
                                        <Typography
                                            variant="h4"
                                            gutterBottom
                                            className={classes.gridHeader}
                                        >
                                            Proof of Identity
                                        </Typography>
                                        <div className={classes.previewPhotoMain}>
                                            <div
                                                className={
                                                    state.status == 'Delivered'
                                                        ? "PreviewPhotoBorderboth"
                                                        : "previewPhotoBorder"
                                                }
                                            >

                                                <div className={"previewPhotoBg"}>
                                                    <img className={state.status == 'Delivered' ? 'bothImageContainer' : 'singleImageContainer'}
                                                        alt=''
                                                        src={
                                                            state.identityProof
                                                                ? "." + state.identityProof + '?v=' + unixTimestamp
                                                                : ''
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </Grid>
                                    {state.status == 'Delivered' && (
                                        <Grid item xs={12} sm={6}>
                                            <Typography
                                                variant="h4"
                                                gutterBottom
                                                className={classes.gridHeader}
                                            >
                                                Proof of Delivery
                                            </Typography>
                                            <div className={classes.previewPhotoMain}>
                                                <div className={"PreviewPhotoBorderboth"}>
                                                    <div className={"previewPhotoBg"}>
                                                        <img className={'bothImageContainer'} src={state.receivingPicturePath + '?v=' + unixTimestamp} />
                                                    </div>
                                                </div>
                                            </div>
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>

                            <Divider variant="fullWidth" style={{ margin: "15px 0 0 0" }} />
                            <Typography
                                variant="h4"
                                gutterBottom
                                className={classes.gridHeader}
                            >
                                Consent and Agreement
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="h6" className={classes.gridValue}>
                                        <span>
                                            <span>Signature</span>
                                            <span>: </span>
                                        </span>
                                        <span className={"signature"}>{state.signature}</span>
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Typography variant="h6" className={classes.gridValue}>
                                        <span>
                                            <span>Your Initials</span>
                                            <span>: </span>
                                        </span>
                                        <span>{state.initials}</span>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Container>
                    </Scrollbars>
                </div>
            </div>
        </Dialog>
    );
}

export default withSnackbar(Preview);
